import BriefInfo from 'components/User/BriefInfo';
import React from 'react';
import { useFreight } from 'useStores/useFreight';

const FreightDetails = () => {
  const choosedFreight = useFreight((state) => state.choosedFreight);
  return <BriefInfo user={choosedFreight} />;
};

export default FreightDetails;
